module.exports = __webpack_public_path__ + "img/U1F437.48ae8cb4.png";